import React from 'react'
import WebsiteFirst from './WebsiteFirst'
import WebsiteSecond from './WebsiteSecond'
import WebsiteThird from './WebsiteThird'
import WebsitePricing from './WebsitePricing'
import WebsiteFourth from './WebsiteFourth'
import ContactSection from './ContactSection'
// import ContactForm from './ContactForm'

 
const WebsiteDevelopmentPage = () => {
  return (
    <div>
      <WebsitePricing/>
      <WebsiteFirst/>
      <WebsiteSecond/>
      <WebsiteThird/>
      <WebsiteFourth/>
      <ContactSection />
      {/* <ContactForm /> */}
    </div>
  )
}

export default WebsiteDevelopmentPage

